import api, { BASE_URL } from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    fr?: string
    es?: string
    ru?: string
    nl?: string
    ar?: string
}

export interface SectorCard {
    _id?: string
    name: LocalizedString
    description: LocalizedString
    icon?: string
    imageUrl?: string
    orderIndex?: number
}

export interface SectorPage {
    _id?: string
    hero: {
        title: LocalizedString
        subtitle: LocalizedString
    }
    sectors: SectorCard[]
}

export const sectorService = {
    getSectorPage: async () => {
        const res = await api.get<SectorPage>('/sector-page')
        const data = res.data
        if (data && data.sectors) {
            data.sectors = data.sectors.map(s => ({
                ...s,
                imageUrl: s.imageUrl?.startsWith('/') ? `${BASE_URL}${s.imageUrl}` : s.imageUrl
            }))
        }
        return data
    },
    updateSectorPage: async (data: Partial<SectorPage>, translate: boolean = false) => {
        const res = await api.put<SectorPage>('/sector-page', data, { params: { translate } })
        return res.data
    },
    uploadSectorImage: async (file: File) => {
        const formData = new FormData()
        formData.append('photo', file)
        const res = await api.post<{ photo: { url: string } }>('/upload/team-photo', formData) // Reusing team-photo upload for now or creating a new one
        return {
            ...res.data,
            photo: {
                ...res.data.photo,
                url: res.data.photo.url?.startsWith('/') ? `${BASE_URL}${res.data.photo.url}` : res.data.photo.url
            }
        }
    }
}
